export const HTTP_400_BAD_REQUEST_CODE = 400;
export const HTTP_401_UNAUTHORIZED_CODE = 401;
export const HTTP_404_NOT_FOUND_CODE = 404;
export const HTTP_405_METHOD_NOT_ALLOWED_CODE = 405;
export const HTTP_500_INTERNAL_SERVER_ERROR_CODE = 500;
export const HTTP_200_OK_CODE = 200;



// WEBPACK FOOTER //
// ./src/constants/HttpStatusCode.js